<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-12">
                            <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                                <div class="row">

                                    <div class="col-xl-6 margin-bottom-0">
                                        <div class="submit-field margin-bottom-0 padding-bottom-0">
                                            <h5>Tipo do cadastro:</h5>
                                        </div>
                                        <div style="width: auto; display: inline-block;" class="radio">
                                            <input style="background: transparent !important; border: 0px !important" id="radio-1" name="radio" type="radio" v-model="form.tipoCadastro" value="F">
                                            <label for="radio-1"><span class="radio-label"></span> Pessoa Física</label>
                                        </div>
                                    
                                        <div style="width: auto; display: inline-block;" class="radio margin-left-20">
                                            <input style="background: transparent !important; border: 0px !important" id="radio-2" name="radio" type="radio" v-model="form.tipoCadastro" value="J">
                                            <label for="radio-2"><span class="radio-label"></span> Pessoa Jurídica</label>
                                        </div>
                                    </div>

                                    <div class="col-xs-12"></div>

                                    <div class="col-xl-6 col-md-6 col-lg-6" v-if="form.tipoCadastro == 'J'">
                                        <div class="submit-field">
                                            <h5>Nome da empresa:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o nome comercial..." required=""  v-model="form.empresa">
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-6" v-if="form.tipoCadastro == 'J'">
                                        <div class="submit-field">
                                            <h5>CNPJ da empresa:</h5>
                                            <the-mask type="tel" :mask="['##.###.###/####-##']" class="form-control" v-model="form.cnpj" :placeholder="'Informe o CNPJ da empresa'"/>    
                                        </div>
                                    </div>                                    


                                    <div class="col-xl-12 margin-bottom-20" v-if="form.tipoCadastro == 'J'">
                                        <hr style="opacity: 0.2;">
                                    </div>

                                    <div class="col-xl-6 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5 v-if="form.tipoCadastro == 'J'">Nome fantasia:</h5>
                                            <h5 v-if="form.tipoCadastro == 'F'">Nome do cliente:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o nome..." required=""  v-model="form.nome">
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>Nome do contato:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o nome do contato..." required=""  v-model="form.contatoNome">
                                        </div>
                                    </div>                                    
                                    <div class="col-xl-6 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>E-mail: (e-mail de acesso ao sistema)</h5>
                                            <input type="text" class="with-border" placeholder="Informe o email..." required=""  v-model="form.email">
                                        </div>
                                    </div>

                                    <div class="col-xl-6 col-lg-6 col-md-6" v-for="(item, index) in form.emails">
                                        <div class="submit-field">
                                            <h5>
                                                E-mail{{ ' (' + (index+1) + ')'}}:
                                                <a v-on:click="delEmail(index)" v-if="index > 0" class="click">
                                                    <i class="material-icons">close</i>
                                                </a>
                                            </h5>
                                            <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.emails[index]">
                                        </div>
                                    </div>
                                    <div class="col-xs-12 hidden-lg hidden-xl hidden-md hidden-sm margin-top-5"></div>
                                    <div class="col-xl-12" style=" margin-bottom: 20px;">
                                        <button type="button" class="button gray small" v-on:click="addEmail">
                                            <i class="material-icons">add</i>
                                            Adicionar e-mail
                                        </button>
                                    </div>   

                                    <div class="col-xl-12"></div>
                                    <div class="col-xs-6 col-xl-3 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>Telefone:</h5>
                                            <the-mask  :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva o telefone" autocomplete="new-password" v-model="form.telefone" />
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 col-md-6 col-lg-6" v-for="(item, index) in form.telefones">
                                        <div class="submit-field">
                                            <h5>
                                                Telefone{{ ' (' + (index+1) + ')'}}:
                                                <a v-on:click="delTelefone(index)" v-if="index > 0" class="click">
                                                    <i class="material-icons">close</i>
                                                </a>
                                            </h5>
                                            <the-mask  :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva o telefone" autocomplete="new-password" v-model="form.telefones[index]" />
                                        </div>
                                    </div>                                    
                                    <div class="col-xs-12 hidden-lg hidden-xl hidden-md hidden-sm margin-top-5"></div>
                                    <div class="col-xl-12" style=" margin-bottom: 20px;">
                                        <button type="button" class="button gray small" v-on:click="addTelefone">
                                            <i class="material-icons">add</i>
                                            Adicionar telefone
                                        </button>
                                    </div>                                       
                                    <div class="col-xl-12"></div>
                                    <div class="col-xs-6 col-xl-2 col-md-3 col-lg-3">
                                        <div class="submit-field">
                                            <h5>RG:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o RG..." required=""  v-model="form.rg">
                                        </div>
                                    </div>                                    
                                    <div class="col-xs-6 col-xl-3 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>CPF:</h5>
                                            <the-mask  :mask="['###.###.###-##']" type="tel" class="form-control" autocomplete="new-password" v-model="form.doc" placeholder="Informe o CPF" required />
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>CEP:</h5>
                                            <the-mask  :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="form.cep" placeholder="_____-___" />
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>Endereço:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o endereço..." required="" v-model="form.endereco">
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-md-6 col-lg-4">
                                        <div class="submit-field">
                                            <h5>Bairro:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o bairro..." required="" v-model="form.bairro">
                                        </div>
                                    </div>                                    
                                    <div class="col-xs-6 col-xl-2 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>Número:</h5>
                                            <input type="text" class="with-border" placeholder="____" required="" v-model="form.numero">
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-lg-6">
                                        <div class="submit-field">
                                            <h5>Complemento:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o complemento..." v-model="form.complemento">
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-6 col-lg-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Cidade:</h5>
                                            <input type="text" class="with-border" placeholder="Informe a cidade..." v-model="form.cidade">
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Estado:</h5>
                                            <select id="estado" class="with-border" readonly="" name="estado" required="" v-model="form.estado">
                                                <option value="" disabled selected hidden>Estado</option>
                                                <option value="AC">Acre</option>
                                                <option value="AL">Alagoas</option>
                                                <option value="AP">Amapá</option>
                                                <option value="AM">Amazonas</option>
                                                <option value="BA">Bahia</option>
                                                <option value="CE">Ceará</option>
                                                <option value="DF">Distrito Federal</option>
                                                <option value="ES">Espírito Santo</option>
                                                <option value="GO">Goiás</option>
                                                <option value="MA">Maranhão</option>
                                                <option value="MT">Mato Grosso</option>
                                                <option value="MS">Mato Grosso do Sul</option>
                                                <option value="MG">Minas Gerais</option>
                                                <option value="PA">Pará</option>
                                                <option value="PB">Paraíba</option>
                                                <option value="PR">Paraná</option>
                                                <option value="PE">Pernambuco</option>
                                                <option value="PI">Piauí</option>
                                                <option value="RJ">Rio de Janeiro</option>
                                                <option value="RN">Rio Grande do Norte</option>
                                                <option value="RS">Rio Grande do Sul</option>
                                                <option value="RO">Rondônia</option>
                                                <option value="RR">Roraima</option>
                                                <option value="SC">Santa Catarina</option>
                                                <option value="SP">São Paulo</option>
                                                <option value="SE">Sergipe</option>
                                                <option value="TO">Tocantins</option>
                                            </select>   
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Categoria do cliente:</h5>
                                            <select id="categoria" class="with-border" readonly="" name="categoria" required="" v-model="form.categoria">
                                                <option value="" disabled selected hidden>Selecione..</option>                              
                                                <option value="CLIENTE DE CONTRATO">Cliente de contrato</option>
                                                <option value="CLIENTE EXTRA">Cliente extra</option>
                                                <!-- <option value="MANUTENÇÃO PREVENTIVA">Manutenção preventiva</option> -->
                                                <!-- <option value="ESCRITÓRIO">Escritório</option> -->
                                                <!-- <option value="CC - ENTREGA DE ENVELOPE">CC - Entrega de envelope</option> -->
                                                <option value="CANCELADO">Cancelado</option>
                                                <option value="PENDÊNCIA FINANCEIRA">Pendência financeira</option>
                                            </select>   
                                        </div>
                                    </div>

                                    <div class="col-xs-12 itens margin-bottom-30 margin-top-10">
                                        <h4>
                                            <i class="las la-list" style="color: #000"></i>
                                            <b>
                                                Equipamentos
                                            </b>
                                        </h4>                                
                                        <table class="table table-bordered">
                                            <thead>
                                                <th style="width: 120px">Quantidade</th>
                                                <th>Nome do equipamento</th>
                                                <th style="width: 50px"></th>
                                            </thead>
                                            <tbody >
                                                <tr v-for="(item, index) in form.equipamentos">
                                                    <td style="padding: 0px">
                                                        <input type="number" v-model="item.quantidade" class="with-border" placeholder="__">
                                                    </td>
                                                    <td style="padding: 0px">
                                                        <input type="text" v-model="item.nome" class="with-border" placeholder="Escreva aqui...">
                                                    </td>
                                                    <td style="padding: 0px">
                                                        <button v-on:click="delItem(item)" type="button" class="button color-red" style="margin-top: -12px; border-radius: 8px !important; height: 49px !important;">
                                                            <i class="las la-times"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <td colspan="2" style="padding: 0px; padding-bottom: 5px;">
                                                    <button v-on:click="addItem" type="button" class="small button grey">Adicionar item</button>
                                                </td>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-xl-12 margin-top-30 margin-bottom-30">
                                        <small class="help" v-if="!form.cod">
                                            Após o cadastro, o cliente receberá no e-mail acima uma senha de acesso gerada pelo sistema.
                                        </small>
                                        <button type="submit" v-if="form.ativo == 1 || !form.cod" class="button color-green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar cliente
                                        </button>
                                        <button v-if="form.cod && form.ativo == 1" type="button" v-on:click="del(form.cod)" class="button outline-gray block-mobile">
                                            <i class="las la-ban"></i>
                                            Excluir cliente
                                        </button>                                                
                                    </div>
                                </div>
                            </form>
                        </div> 
                    </div>                

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarClientes',
    components: {
        'AvatarCropper': AvatarCropper,
        'Top':      Top,
        'Sidebar':  Sidebar,
        'Toolbar':  Toolbar
    },          
    data () {
        var self                    = this;
        return {
            "salvo":                false,
            "erroCep":              false,
            "detalhes":             null,
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },            
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "email":            "",
                "telefone":         "",
                "categoria":        "",
                "cep":              "",
                "estado":           "",
                "equipamentos":     [],
                "emails":           [],
                "telefones":        [],
                "tipoCadastro":     "F",
                "doc":              ""
            }            
        }
    },
    watch: {
        "form.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },
    },    
    methods: {
        addEmail: function() {
            console.log("addEmail()");
            var self = this;
            self.form.emails.push("");
        },
        delEmail: function(i) {
            console.log("delEmail()", i)
            var self = this;
            self.form.emails.splice(i, 1);
        },   
        addTelefone: function() {
            console.log("addTelefone()");
            var self = this;
            self.form.telefones.push("");
        },
        delTelefone: function(i) {
            console.log("delTelefone()", i)
            var self = this;
            self.form.telefones.splice(i, 1);
        },                
        addItem: function() {
            var self = this;
            self.form.equipamentos.push({
                "nome": "",
                "valor": 0
            });
            self.$forceUpdate();
        },
        delItem: function(item) {
            var self = this;
            self.form.equipamentos.splice(self.form.equipamentos.indexOf(item), 1);
            self.$forceUpdate();
        },           
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            // self.form.imagem = e.getCroppedCanvas().toDataURL();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 800, Infinity, 0.6, blob2 => {
                    blobToBase64(blob2, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form.imagem    = result;
                        self.$forceUpdate();
                    });
                });             
            });
            return true;
        },         
        getBase64Imagem: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();                   
                reduceFileSize(event.target.files[0], 500*1024, 800, Infinity, 0.6, blob => {
                    blobToBase64(blob, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form[event.target.id.split("-")[2]]    = result;
                    });
                }); 
            } else {
                setTimeout(function() {
                    loading.hide();
                }, 500);                
            } 
        },         
        escolherArquivo: function(campo) {
            console.log("escolherArquivo()", campo)
            var self = this;
            $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
         
        },             
        escolherImagem: function(campo) {
            console.log("escolherImagem()", campo)
            var self = this;
            $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
            
        },           
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (!response.data.erro) {
                                self.form.endereco  = response.data.logradouro;
                                self.form.bairro    = response.data.bairro;
                                self.form.cidade    = response.data.localidade;
                                self.form.estado    = response.data.uf;
                                self.erroCep = false;
                                self.$forceUpdate();
                            } else {
                                self.erroCep = true;
                                self.$forceUpdate();
                                alert("Erro ao buscar endereço do CEP! Verifique o CEP digitado e tente novamente por favor.");
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },  
        submit: function(e) {
            
            var self            = this;
            // if (self.form.tipo != "admin" && self.form.tipo != "prestador") return false;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();

            if (self.erroCep) {
                alert("Erro ao buscar endereço do CEP! Verifique o CEP digitado e tente novamente por favor.");
                return false;
            }

            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            var request = function() {
                axios[a]("api/clientes.php", self.form)
                .then(response => {
                    
                    self.salvo          = true;
                    self.loading.submit = false;
                    console.log("submit() response", response)
                    loading.hide();
                    alert(response.data.message);
                    self.$root.back();
                    
                })
                .catch(error => {
                    console.log("submit() error", error)
                    loading.hide();
                    self.loading.submit = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });                
            }

            if (!self.detalhes || (self.detalhes ? (self.detalhes.endereco != self.form.endereco || self.detalhes.numero != self.form.numero || self.detalhes.cep != self.form.cep) : false)) {
                var geocoder                = new google.maps.Geocoder();
                var endereco                = self.form.endereco + ", " + self.form.numero + " - " + self.form.bairro + ", " + self.form.cidade + " - " + self.form.estado + ", " + self.form.cep;
                geocoder.geocode({ 'address': endereco}, function (results, status) {

                    console.log("Localizacao resultado >>", results)
                    if (results) {

                        var latitude        = results[0].geometry.location.lat();
                        var longitude       = results[0].geometry.location.lng();
                        self.form.latitude       = latitude;
                        self.form.longitude      = longitude;
                        console.log("Setou localizacao", self.form);
                        self.$forceUpdate();

                        request();
                    } else {
                        loading.hide();
                        alert("Erro! Informe um endereço válido e tente novamente por favor.")
                    }

                });   
            } else {
                request();
            }


        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.detalhes       = JSON.parse(JSON.stringify(response.data.result));
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };
                loading.show();
                
                axios.delete("api/clientes.php", form)
                .then(response => {
                    console.log("del() response", response)
                    self.salvo          = true;
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },                   
    },    
    created: function() {
        var self = this;
        console.log("created", self);

    },
    activated: function() {
        var self = this;

        self.$root.confirmacaoSair = true;

        if (self.$route.name == "EditarClientes") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            loading.show();
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }    

    .uploadButton .uploadButton-input {
        opacity: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarClientes.vue